<template>
  <div class="h-full grid grid-cols-1 sm:grid-cols-2 items-center">
    <div class="auth-block items-center hidden sm:flex" />
    <div class="auth-block justify-center flex-col gap-1">
      <RouterView />
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style scoped>
.auth-block {
  @apply h-full flex p-4;
}

.p-divider::before {
  border-top: 1px solid black !important;
}
</style>
